var _excluded = ["intl"];
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
import React from 'react';
import { injectIntl, intlShape } from '@edx/frontend-platform/i18n';
import { faFacebookSquare, faTwitterSquare, faLinkedin, faRedditSquare, faInstagram } from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import messages from './Footer.messages';
var SocialIconLinks = function SocialIconLinks(_ref) {
  var intl = _ref.intl,
    props = _objectWithoutProperties(_ref, _excluded);
  var iconLinks = [{
    title: 'Facebook',
    url: 'http://www.facebook.com/EdxOnline',
    icon: /*#__PURE__*/React.createElement(FontAwesomeIcon, {
      icon: faFacebookSquare,
      className: "social-icon",
      size: "2x"
    }),
    screenReaderText: intl.formatMessage(messages['footer.socialLinks.srText.facebook'])
  }, {
    title: 'Twitter',
    url: 'https://twitter.com/edXOnline',
    icon: /*#__PURE__*/React.createElement(FontAwesomeIcon, {
      icon: faTwitterSquare,
      className: "social-icon",
      size: "2x"
    }),
    screenReaderText: intl.formatMessage(messages['footer.socialLinks.srText.twitter'])
  }, {
    title: 'LinkedIn',
    url: 'http://www.linkedin.com/company/edx',
    icon: /*#__PURE__*/React.createElement(FontAwesomeIcon, {
      icon: faLinkedin,
      className: "social-icon",
      size: "2x"
    }),
    screenReaderText: intl.formatMessage(messages['footer.socialLinks.srText.linkedin'])
  }, {
    title: 'Instagram',
    url: 'https://www.instagram.com/edxonline/',
    icon: /*#__PURE__*/React.createElement(FontAwesomeIcon, {
      icon: faInstagram,
      className: "social-icon",
      size: "2x"
    }),
    screenReaderText: intl.formatMessage(messages['footer.socialLinks.srText.instagram'])
  }, {
    title: 'Reddit',
    url: 'http://www.reddit.com/r/edx',
    icon: /*#__PURE__*/React.createElement(FontAwesomeIcon, {
      icon: faRedditSquare,
      className: "social-icon",
      size: "2x"
    }),
    screenReaderText: intl.formatMessage(messages['footer.socialLinks.srText.reddit'])
  }].map(function (link) {
    return /*#__PURE__*/React.createElement("li", {
      key: link.url
    }, /*#__PURE__*/React.createElement("a", _extends({
      href: link.url,
      title: link.title,
      rel: "noopener noreferrer",
      target: "_blank"
    }, props), link.icon, /*#__PURE__*/React.createElement("span", {
      className: "sr-only"
    }, link.screenReaderText)));
  });
  // eslint-disable-next-line react/jsx-no-useless-fragment
  return /*#__PURE__*/React.createElement(React.Fragment, null, iconLinks);
};
export default injectIntl(SocialIconLinks);